/* eslint-disable react/jsx-props-no-spreading */
import { ComponentProps } from 'preact';

import {
  MuteControlButton as PlainMuteControlButton,
  PlayPauseButton as PlainPlayPauseButton,
  SoundControlButtonGroup as PlainSoundControlButtonGroup,
} from '@/components/VideoControls/buttons';
import withDefaults from '@/components/withDefaults';

import { useLiveStreamPlayerStateContext } from '../../contexts';

const Container = withDefaults('div', {
  className:
    'absolute inset-x-0 bottom-0 flex bg-[rgb(69_130_84/.65)] p-1 text-[22px] text-white desktop:grid desktop:grid-cols-3',
});

const ButtonsGroup = withDefaults('div', {
  className: 'flex gap-2',
});

interface OnValueChangeProps<T> {
  onValueChange?: (val: T) => void;
}

const PlayPauseButton = ({
  onClick,
  onValueChange,
  ...rest
}: ComponentProps<typeof PlainPlayPauseButton> & OnValueChangeProps<boolean>) => {
  const { isPlaying, requestChangePlayingState } = useLiveStreamPlayerStateContext();
  return (
    <PlainPlayPauseButton
      value={isPlaying}
      onClick={(event) => {
        requestChangePlayingState(!isPlaying);
        onValueChange?.(!isPlaying);
        onClick?.(event);
      }}
      {...rest}
    />
  );
};

const MuteControlButton = ({
  onClick,
  onValueChange,
  ...rest
}: ComponentProps<typeof PlainPlayPauseButton> & OnValueChangeProps<boolean>) => {
  const { isMuted, requestChangeMuteState } = useLiveStreamPlayerStateContext();
  return (
    <PlainMuteControlButton
      value={isMuted}
      onClick={(event) => {
        requestChangeMuteState(!isMuted);
        onValueChange?.(!isMuted);
        onClick?.(event);
      }}
      {...rest}
    />
  );
};

const SoundControlButtonGroup = ({ onMutedChange, ...rest }: ComponentProps<typeof PlainSoundControlButtonGroup>) => {
  const { volume, requestChangeVolume, isMuted, requestChangeMuteState } = useLiveStreamPlayerStateContext();
  return (
    <PlainSoundControlButtonGroup
      orientation="vertical"
      volume={volume}
      onVolumeChange={requestChangeVolume}
      isMuted={isMuted}
      onMutedChange={(newValue) => {
        requestChangeMuteState(newValue);
        onMutedChange?.(newValue);
      }}
      {...rest}
    />
  );
};

const LiveStreamPlayerControlsFull = {
  Container,
  ButtonsGroup,
  PlayPauseButton,
  MuteControlButton,
  SoundControlButtonGroup,
};

export default LiveStreamPlayerControlsFull;
